export enum ObligationStateIcons {
  ERFULLT = '<svg id="uuid-dcc5766b-394f-477a-b369-d4f4a51021b1" style="width: 20px; vertical-align: middle;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><defs><style>.uuid-9649323e-4b77-4d5b-ae28-5c586921e36a{fill:#3faf6c;}.uuid-55c5954e-6eac-40be-af90-00b20aa4efc1{fill:#fff;}.uuid-d2e7ecba-3f89-4f9d-ab22-a3eeb340d8c8{fill:#ddd;}</style></defs><circle class="uuid-55c5954e-6eac-40be-af90-00b20aa4efc1" cx="10" cy="10" r="9"/><circle class="uuid-9649323e-4b77-4d5b-ae28-5c586921e36a" cx="10" cy="10" r="6.3"/><path class="uuid-d2e7ecba-3f89-4f9d-ab22-a3eeb340d8c8" d="M10,19.5C4.76,19.5,.5,15.24,.5,10S4.76,.5,10,.5s9.5,4.26,9.5,9.5-4.26,9.5-9.5,9.5ZM10,1.5C5.31,1.5,1.5,5.31,1.5,10s3.81,8.5,8.5,8.5,8.5-3.81,8.5-8.5S14.69,1.5,10,1.5Z"/></svg>',
  OFFEN = '<svg id="uuid-dcc5766b-394f-477a-b369-d4f4a51021b2" style="width: 20px; vertical-align: middle;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><defs><style>.uuid-9649323e-4b77-4d5b-ae28-5c586921e36a{fill:#707070;}.uuid-55c5954e-6eac-40be-af90-00b20aa4efc1{fill:#fff;}.uuid-d2e7ecba-3f89-4f9d-ab22-a3eeb340d8c8{fill:#ddd;}</style></defs><circle class="uuid-55c5954e-6eac-40be-af90-00b20aa4efc1" cx="10" cy="10" r="9"/><circle class="uuid-9649323e-4b77-4d5b-ae28-5c586921e36a" cx="10" cy="10" r="6.3"/><path class="uuid-d2e7ecba-3f89-4f9d-ab22-a3eeb340d8c8" d="M10,19.5C4.76,19.5,.5,15.24,.5,10S4.76,.5,10,.5s9.5,4.26,9.5,9.5-4.26,9.5-9.5,9.5ZM10,1.5C5.31,1.5,1.5,5.31,1.5,10s3.81,8.5,8.5,8.5,8.5-3.81,8.5-8.5S14.69,1.5,10,1.5Z"/></svg>',
  FALLIG = '<svg id="uuid-dcc5766b-394f-477a-b369-d4f4a51021b3" style="width: 20px; vertical-align: middle;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><defs><style>.uuid-9649323e-4b77-4d5b-ae28-5c586921e36a{fill:#DB1111;}.uuid-55c5954e-6eac-40be-af90-00b20aa4efc1{fill:#fff;}.uuid-d2e7ecba-3f89-4f9d-ab22-a3eeb340d8c8{fill:#ddd;}</style></defs><circle class="uuid-55c5954e-6eac-40be-af90-00b20aa4efc1" cx="10" cy="10" r="9"/><circle class="uuid-9649323e-4b77-4d5b-ae28-5c586921e36a" cx="10" cy="10" r="6.3"/><path class="uuid-d2e7ecba-3f89-4f9d-ab22-a3eeb340d8c8" d="M10,19.5C4.76,19.5,.5,15.24,.5,10S4.76,.5,10,.5s9.5,4.26,9.5,9.5-4.26,9.5-9.5,9.5ZM10,1.5C5.31,1.5,1.5,5.31,1.5,10s3.81,8.5,8.5,8.5,8.5-3.81,8.5-8.5S14.69,1.5,10,1.5Z"/></svg>',
  UBERFALLIG = '<svg id="uuid-dcc5766b-394f-477a-b369-d4f4a51021b4" style="width: 20px; vertical-align: middle;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><defs><style>.uuid-9649323e-4b77-4d5b-ae28-5c586921e36a{fill:#E3D700;}.uuid-55c5954e-6eac-40be-af90-00b20aa4efc1{fill:#fff;}.uuid-d2e7ecba-3f89-4f9d-ab22-a3eeb340d8c8{fill:#ddd;}</style></defs><circle class="uuid-55c5954e-6eac-40be-af90-00b20aa4efc1" cx="10" cy="10" r="9"/><circle class="uuid-9649323e-4b77-4d5b-ae28-5c586921e36a" cx="10" cy="10" r="6.3"/><path class="uuid-d2e7ecba-3f89-4f9d-ab22-a3eeb340d8c8" d="M10,19.5C4.76,19.5,.5,15.24,.5,10S4.76,.5,10,.5s9.5,4.26,9.5,9.5-4.26,9.5-9.5,9.5ZM10,1.5C5.31,1.5,1.5,5.31,1.5,10s3.81,8.5,8.5,8.5,8.5-3.81,8.5-8.5S14.69,1.5,10,1.5Z"/></svg>',
}

export enum DelegationStateIcons {
  DELEGIERT = '<svg id="uuid-dcc5766b-394f-477a-b369-d4f4a51021b1" style="width: 20px; vertical-align: middle;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><defs><style>.uuid-9649323e-4b77-4d5b-ae28-5c586921e36a{fill:#3faf6c;}.uuid-55c5954e-6eac-40be-af90-00b20aa4efc1{fill:#fff;}.uuid-d2e7ecba-3f89-4f9d-ab22-a3eeb340d8c8{fill:#ddd;}</style></defs><circle class="uuid-55c5954e-6eac-40be-af90-00b20aa4efc1" cx="10" cy="10" r="9"/><circle class="uuid-9649323e-4b77-4d5b-ae28-5c586921e36a" cx="10" cy="10" r="6.3"/><path class="uuid-d2e7ecba-3f89-4f9d-ab22-a3eeb340d8c8" d="M10,19.5C4.76,19.5,.5,15.24,.5,10S4.76,.5,10,.5s9.5,4.26,9.5,9.5-4.26,9.5-9.5,9.5ZM10,1.5C5.31,1.5,1.5,5.31,1.5,10s3.81,8.5,8.5,8.5,8.5-3.81,8.5-8.5S14.69,1.5,10,1.5Z"/></svg>',
  OFFEN = '<svg id="uuid-adbdee77-7eeb-44bb-8486-3a2a93fd7221" style="width: 20px; vertical-align: middle;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><defs><style>.uuid-5e57959e-7318-476e-967a-71063d739bff{fill:#fff;}.uuid-7884f72d-baf1-450b-8f5f-82f2aafb8934{fill:#ddd;}.uuid-fde60553-142b-44da-b887-3f173436415d{fill:#ec6446;}</style></defs><circle class="uuid-5e57959e-7318-476e-967a-71063d739bff" cx="10" cy="10" r="9"/><circle class="uuid-fde60553-142b-44da-b887-3f173436415d" cx="10" cy="10" r="6.3"/><path class="uuid-7884f72d-baf1-450b-8f5f-82f2aafb8934" d="M10,19.5C4.76,19.5,.5,15.24,.5,10S4.76,.5,10,.5s9.5,4.26,9.5,9.5-4.26,9.5-9.5,9.5ZM10,1.5C5.31,1.5,1.5,5.31,1.5,10s3.81,8.5,8.5,8.5,8.5-3.81,8.5-8.5S14.69,1.5,10,1.5Z"/></svg>',
}

export enum StateIcon {
  Open = '<svg style="width: 20px; vertical-align: middle;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><defs><style>.measure-state-open{fill:#989898;}.uuid-55c5954e-6eac-40be-af90-00b20aa4efc1{fill:#fff;}.uuid-d2e7ecba-3f89-4f9d-ab22-a3eeb340d8c8{fill:#ddd;}</style></defs><circle class="measure-state-open" cx="10" cy="10" r="9"/><circle class="measure-state-open" cx="10" cy="10" r="6.3"/><path class="uuid-d2e7ecba-3f89-4f9d-ab22-a3eeb340d8c8" d="M10,19.5C4.76,19.5,.5,15.24,.5,10S4.76,.5,10,.5s9.5,4.26,9.5,9.5-4.26,9.5-9.5,9.5ZM10,1.5C5.31,1.5,1.5,5.31,1.5,10s3.81,8.5,8.5,8.5,8.5-3.81,8.5-8.5S14.69,1.5,10,1.5Z"/></svg>',
  AfterDueDate = '<svg style="width: 20px; vertical-align: middle;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><defs><style>.measure-state-before-due-date{fill:#ef7461;}.uuid-55c5954e-6eac-40be-af90-00b20aa4efc1{fill:#fff;}.uuid-d2e7ecba-3f89-4f9d-ab22-a3eeb340d8c8{fill:#ddd;}</style></defs><circle class="measure-state-before-due-date" cx="10" cy="10" r="9"/><circle class="measure-state-before-due-date" cx="10" cy="10" r="6.3"/><path class="uuid-d2e7ecba-3f89-4f9d-ab22-a3eeb340d8c8" d="M10,19.5C4.76,19.5,.5,15.24,.5,10S4.76,.5,10,.5s9.5,4.26,9.5,9.5-4.26,9.5-9.5,9.5ZM10,1.5C5.31,1.5,1.5,5.31,1.5,10s3.81,8.5,8.5,8.5,8.5-3.81,8.5-8.5S14.69,1.5,10,1.5Z"/></svg>',
  BeforeDueDate = '<svg style="width: 20px; vertical-align: middle;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><defs><style>.measure-state-after-due-date{fill:#fee583;}.uuid-55c5954e-6eac-40be-af90-00b20aa4efc1{fill:#fff;}.uuid-d2e7ecba-3f89-4f9d-ab22-a3eeb340d8c8{fill:#ddd;}</style></defs><circle class="measure-state-after-due-date" cx="10" cy="10" r="9"/><circle class="measure-state-after-due-date" cx="10" cy="10" r="6.3"/><path class="uuid-d2e7ecba-3f89-4f9d-ab22-a3eeb340d8c8" d="M10,19.5C4.76,19.5,.5,15.24,.5,10S4.76,.5,10,.5s9.5,4.26,9.5,9.5-4.26,9.5-9.5,9.5ZM10,1.5C5.31,1.5,1.5,5.31,1.5,10s3.81,8.5,8.5,8.5,8.5-3.81,8.5-8.5S14.69,1.5,10,1.5Z"/></svg>',
  Done = '<svg style="width: 20px; vertical-align: middle;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><defs><style>.measure-state-done{fill:#39aa64;}.uuid-55c5954e-6eac-40be-af90-00b20aa4efc1{fill:#fff;}.uuid-d2e7ecba-3f89-4f9d-ab22-a3eeb340d8c8{fill:#ddd;}</style></defs><circle class="measure-state-done" cx="10" cy="10" r="9"/><circle class="measure-state-done" cx="10" cy="10" r="6.3"/><path class="uuid-d2e7ecba-3f89-4f9d-ab22-a3eeb340d8c8" d="M10,19.5C4.76,19.5,.5,15.24,.5,10S4.76,.5,10,.5s9.5,4.26,9.5,9.5-4.26,9.5-9.5,9.5ZM10,1.5C5.31,1.5,1.5,5.31,1.5,10s3.81,8.5,8.5,8.5,8.5-3.81,8.5-8.5S14.69,1.5,10,1.5Z"/></svg>',
  Permanent = '<svg style="width: 20px; vertical-align: middle;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><defs><style>.measure-state-done{fill:#a6d189;}.uuid-55c5954e-6eac-40be-af90-00b20aa4efc1{fill:#fff;}.uuid-d2e7ecba-3f89-4f9d-ab22-a3eeb340d8c8{fill:#ddd;}</style></defs><circle class="measure-state-done" cx="10" cy="10" r="9"/><circle class="measure-state-done" cx="10" cy="10" r="6.3"/><path class="uuid-d2e7ecba-3f89-4f9d-ab22-a3eeb340d8c8" d="M10,19.5C4.76,19.5,.5,15.24,.5,10S4.76,.5,10,.5s9.5,4.26,9.5,9.5-4.26,9.5-9.5,9.5ZM10,1.5C5.31,1.5,1.5,5.31,1.5,10s3.81,8.5,8.5,8.5,8.5-3.81,8.5-8.5S14.69,1.5,10,1.5Z"/></svg>',
  Repetitive = '<svg style="width: 20px; vertical-align: middle;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><defs><style>.measure-state-done{fill:#69bb76;}.uuid-55c5954e-6eac-40be-af90-00b20aa4efc1{fill:#fff;}.uuid-d2e7ecba-3f89-4f9d-ab22-a3eeb340d8c8{fill:#ddd;}</style></defs><circle class="measure-state-done" cx="10" cy="10" r="9"/><circle class="measure-state-done" cx="10" cy="10" r="6.3"/><path class="uuid-d2e7ecba-3f89-4f9d-ab22-a3eeb340d8c8" d="M10,19.5C4.76,19.5,.5,15.24,.5,10S4.76,.5,10,.5s9.5,4.26,9.5,9.5-4.26,9.5-9.5,9.5ZM10,1.5C5.31,1.5,1.5,5.31,1.5,10s3.81,8.5,8.5,8.5,8.5-3.81,8.5-8.5S14.69,1.5,10,1.5Z"/></svg>',
  Noted = '<svg style="width: 20px; vertical-align: middle;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><defs><style>.measure-state-done{fill:#6b85c0;}.uuid-55c5954e-6eac-40be-af90-00b20aa4efc1{fill:#fff;}.uuid-d2e7ecba-3f89-4f9d-ab22-a3eeb340d8c8{fill:#ddd;}</style></defs><circle class="measure-state-done" cx="10" cy="10" r="9"/><circle class="measure-state-done" cx="10" cy="10" r="6.3"/><path class="uuid-d2e7ecba-3f89-4f9d-ab22-a3eeb340d8c8" d="M10,19.5C4.76,19.5,.5,15.24,.5,10S4.76,.5,10,.5s9.5,4.26,9.5,9.5-4.26,9.5-9.5,9.5ZM10,1.5C5.31,1.5,1.5,5.31,1.5,10s3.81,8.5,8.5,8.5,8.5-3.81,8.5-8.5S14.69,1.5,10,1.5Z"/></svg>',
}

export enum State {
  Open = 'enum-state-open',
  BeforeDueDate = 'enum-state-due',
  AfterDueDate = 'enum-state-overdue',
  Noted = 'enum-state-noted',

  OneTime = 'enum-state-one-time',
  Permanent = 'enum-state-permanent',

  Repetitive = 'enum-state-repetitive',
  Done = 'enum-state-finished',
}

export enum Responsibility {
  Control = '0',
  Execution = '1',
  ControlAndExecution = '2',
}

export enum ResponsibilityText {
  Control = 'enum-responsibility-control',
  Execution = 'enum-responsibility-execution',
}

export enum DefaultIcons {
  ACTIVEPDF = `<svg id="uuid-d2a55715-32b7-44ad-b41b-f3db70558c38" width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 38"><defs><style>.uuid-297c3cbf-0d3c-4132-8fbb-d5d2295eecc6{fill:#232932;}</style></defs><path class="uuid-297c3cbf-0d3c-4132-8fbb-d5d2295eecc6" d="m9.24,30.62c-.43,0-.82-.16-1.14-.46-.74-.7-1-1.57-.76-2.51.57-2.2,3.91-4.38,7.57-5.82.47-.89.92-1.79,1.3-2.65.41-.92.76-1.8,1.06-2.61-1.22-2.18-2.36-5-1.7-7.06.31-.98,1.02-1.67,2.05-2.01,1.08-.35,1.71.11,1.99.42,1.22,1.35.58,4.88-.69,8.51.42.71.9,1.44,1.43,2.17.4.55.85,1.06,1.33,1.52,3.28-.41,6.99-.33,8.45,1.18.59.62.77,1.41.52,2.28-.22.76-.83,1.27-1.71,1.42-2.01.36-5.25-1.13-7.74-3.31-.86.13-1.74.3-2.6.52-.92.23-1.8.51-2.63.82-1.74,3.19-4.33,7.15-6.35,7.55-.12.02-.25.04-.37.04Zm4.44-6.62c-2.74,1.33-4.59,2.9-4.89,4.03-.1.4,0,.73.34,1.05.04.03.07.06.18.04.98-.2,2.73-2.41,4.37-5.12Zm9.6-2.54c2.07,1.49,4.28,2.26,5.39,2.06.44-.08.5-.27.53-.37.13-.44,0-.66-.16-.82-.74-.77-3.04-1.07-5.77-.88Zm-5.06-.7l.19.73-.19-.73c.5-.13,1.07-.25,1.67-.36-.27-.3-.52-.61-.74-.92-.22-.3-.53-.74-.88-1.28-.22.54-.44,1.07-.67,1.6-.16.36-.37.81-.63,1.33.42-.13.84-.25,1.26-.36Zm.13-11.89c-.06,0-.14.01-.26.05-.58.19-.92.52-1.09,1.05-.33,1.01.04,2.68.94,4.61.96-3.19.99-5.18.55-5.66-.02-.02-.05-.06-.15-.06Z"/><path class="uuid-297c3cbf-0d3c-4132-8fbb-d5d2295eecc6" d="m32.12,37.25H5.88c-2.83,0-5.12-2.3-5.12-5.12V5.88C.75,3.05,3.05.75,5.88.75h26.25c2.83,0,5.12,2.3,5.12,5.12v26.25c0,2.83-2.3,5.12-5.12,5.12ZM5.88,2.25c-2,0-3.62,1.63-3.62,3.62v26.25c0,2,1.63,3.62,3.62,3.62h26.25c2,0,3.62-1.63,3.62-3.62V5.88c0-2-1.63-3.62-3.62-3.62H5.88Z"/></svg>`,
  INACTIVEPDF = `<svg fill="#999da1" width="20px" height="20px" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg">
<g fill-rule="evenodd">
    <path d="M1251.654 0c44.499 0 88.207 18.07 119.718 49.581l329.223 329.224c31.963 31.962 49.581 74.54 49.581 119.717V1920H169V0Zm-66.183 112.941H281.94V1807.06h1355.294V564.706H1185.47V112.94Zm112.94 23.379v315.445h315.445L1298.412 136.32Z"/>
    <path d="M900.497 677.67c26.767 0 50.372 12.65 67.991 37.835 41.901 59.068 38.965 121.976 23.492 206.682-5.308 29.14.113 58.617 16.263 83.125 22.814 34.786 55.68 82.673 87.981 123.219 23.718 29.93 60.198 45.854 97.13 40.885 23.718-3.276 52.292-5.986 81.656-5.986 131.012 0 121.186 46.757 133.045 89.675 6.55 25.976 3.275 48.678-10.165 65.506-16.715 22.701-51.162 34.447-101.534 34.447-55.793 0-74.202-9.487-122.767-24.96-27.445-8.81-55.906-10.617-83.69-3.275-55.453 14.456-146.936 36.48-223.284 46.983-40.772 5.647-77.816 26.654-102.438 60.875-55.454 76.8-106.842 148.518-188.273 148.518-21.007 0-40.32-7.567-56.244-22.701-23.492-23.492-33.544-49.581-28.574-79.85 13.778-92.95 128.075-144.79 196.066-182.625 16.037-8.923 28.687-22.589 36.592-39.53l107.86-233.223c7.68-16.377 10.051-34.56 7.228-52.518-12.537-79.059-31.06-211.99 18.748-272.075 10.955-13.44 26.09-21.007 42.917-21.007Zm20.556 339.953c-43.257 126.607-119.718 264.282-129.996 280.32 92.273-43.37 275.916-65.28 275.916-65.28-92.386-88.998-145.92-215.04-145.92-215.04Z"/>
</g>
</svg>`,
  OPENDETAIL = `<svg fill="#000000" width="20px" height="20px" viewBox="0 0 24 24" id="right-arrow-direction-square" xmlns="http://www.w3.org/2000/svg" class="icon line"><path id="primary" d="M3,20V4A1,1,0,0,1,4,3H20a1,1,0,0,1,1,1V20a1,1,0,0,1-1,1H4A1,1,0,0,1,3,20Zm4-8h5m4.63-.69L13.5,9.17a1,1,0,0,0-1.5.69v4.28a1,1,0,0,0,1.5.69l3.12-2.14A.82.82,0,0,0,16.63,11.31Z" style="fill: none; stroke: rgb(0, 0, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.5;"></path></svg>`,
  EYE = `<svg fill="#000000" width="20px" height="20px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
  <path d="M16.108 10.044c-3.313 0-6 2.687-6 6s2.687 6 6 6 6-2.686 6-6-2.686-6-6-6zM16.108 20.044c-2.206 0-4.046-1.838-4.046-4.044s1.794-4 4-4c2.206 0 4 1.794 4 4s-1.748 4.044-3.954 4.044zM31.99 15.768c-0.012-0.050-0.006-0.104-0.021-0.153-0.006-0.021-0.020-0.033-0.027-0.051-0.011-0.028-0.008-0.062-0.023-0.089-2.909-6.66-9.177-10.492-15.857-10.492s-13.074 3.826-15.984 10.486c-0.012 0.028-0.010 0.057-0.021 0.089-0.007 0.020-0.021 0.030-0.028 0.049-0.015 0.050-0.009 0.103-0.019 0.154-0.018 0.090-0.035 0.178-0.035 0.269s0.017 0.177 0.035 0.268c0.010 0.050 0.003 0.105 0.019 0.152 0.006 0.023 0.021 0.032 0.028 0.052 0.010 0.027 0.008 0.061 0.021 0.089 2.91 6.658 9.242 10.428 15.922 10.428s13.011-3.762 15.92-10.422c0.015-0.029 0.012-0.058 0.023-0.090 0.007-0.017 0.020-0.030 0.026-0.050 0.015-0.049 0.011-0.102 0.021-0.154 0.018-0.090 0.034-0.177 0.034-0.27 0-0.088-0.017-0.175-0.035-0.266zM16 25.019c-5.665 0-11.242-2.986-13.982-8.99 2.714-5.983 8.365-9.047 14.044-9.047 5.678 0 11.203 3.067 13.918 9.053-2.713 5.982-8.301 8.984-13.981 8.984z"></path>
</svg>`,
  REMOVE = `<svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 12V17" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14 12V17" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4 7H20" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6 10V18C6 19.6569 7.34315 21 9 21H15C16.6569 21 18 19.6569 18 18V10" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
  PADLOCK = `<svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.1819 10.7027H6.00008C5.44781 10.7027 5.0001 11.1485 5.00009 11.7008C5.00005 13.3483 5 16.6772 5.00011 18.9189C5.00023 21.4317 8.88618 22 12 22C15.1139 22 19 21.4317 19 18.9189C19 16.6773 19 13.3483 19 11.7008C19 11.1485 18.5523 10.7027 18 10.7027H15.8182M8.1819 10.7027C8.1819 10.7027 8.18193 8.13514 8.1819 6.59459C8.18186 4.74571 9.70887 3 12 3C14.2912 3 15.8182 4.74571 15.8182 6.59459C15.8182 8.13514 15.8182 10.7027 15.8182 10.7027M8.1819 10.7027H15.8182" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M13 16.6181V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V16.6181C10.6931 16.3434 10.5 15.9442 10.5 15.5C10.5 14.6716 11.1716 14 12 14C12.8284 14 13.5 14.6716 13.5 15.5C13.5 15.9442 13.3069 16.3434 13 16.6181Z" fill="#000000"/>
</svg>`,
  PADUNLOCK = `<svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.50005 11.3932C4.50001 13.1319 4.49995 16.764 4.50007 19.1988C4.5002 21.8911 8.66375 22.5 12.0001 22.5C15.3364 22.5 19.5 21.8911 19.5 19.1988L19.5 11.3932C19.5 10.8409 19.0523 10.3957 18.5 10.3957H5.50004C4.94777 10.3957 4.50006 10.8409 4.50005 11.3932ZM10.5 16.0028C10.5 16.4788 10.7069 16.9065 11.0357 17.2008V18.7529C11.0357 19.3051 11.4834 19.7529 12.0357 19.7529H12.1786C12.7309 19.7529 13.1786 19.3051 13.1786 18.7529V17.2008C13.5074 16.9065 13.7143 16.4788 13.7143 16.0028C13.7143 15.1152 12.9948 14.3957 12.1072 14.3957C11.2195 14.3957 10.5 15.1152 10.5 16.0028Z" fill="#000000"/>
<path d="M8.18164 10.7027C8.18164 10.7027 8.18168 8.13513 8.18164 6.59459C8.1816 4.74571 9.70861 3 11.9998 3C14.291 3 15.8179 4.74571 15.8179 6.59459" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
  REMOVEDOCUMENT = `
  <svg version="1.1" width="20px" height="20px" id="Icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
     viewBox="0 0 32 32" xml:space="preserve">
  <style type="text/css">
    .st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
    .st1{fill:none;stroke:#000000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}
  </style>
  <polyline class="st0" points="19,3 19,9 25,9 19,3 7,3 7,29 22,29 "/>
  <circle class="st0" cx="22" cy="22" r="7"/>
  <line class="st0" x1="25" y1="9" x2="25" y2="15.7"/>
  <line class="st0" x1="19.9" y1="19.9" x2="24.1" y2="24.1"/>
  <line class="st0" x1="19.9" y1="24.1" x2="24.1" y2="19.9"/>
  </svg>`,
  CONTEXTMENU = `<svg id="context-menu-icon" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400"><defs><style>.context-menu-icon{fill:#6e6e7d;}</style></defs><circle class="context-menu-icon" cx="200" cy="60" r="40"/><circle class="context-menu-icon" cx="200" cy="340" r="40"/><circle class="context-menu-icon" cx="200" cy="200" r="40"/></svg>`,
  ASSIGNED = `<svg id="cls-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><defs><style>.cls-1{fill:#afafaf;}</style></defs><path class="cls-1" d="m22.95,12.54c.64-.71,1.03-1.64,1.03-2.66,0-2.2-1.79-3.99-3.99-3.99s-3.99,1.79-3.99,3.99c0,1.02.39,1.96,1.02,2.66-2.29.37-3.96,1.48-4.23,4.74-.04.41.27.78.68.81.41.04.78-.27.81-.68.26-3.03,1.65-3.54,5.7-3.54s5.44.51,5.7,3.54c.03.39.36.69.75.69.02,0,.04,0,.06,0,.41-.04.72-.4.68-.81-.28-3.26-1.95-4.37-4.24-4.74Zm-2.96-5.15c1.37,0,2.49,1.11,2.49,2.49s-1.12,2.49-2.49,2.49-2.49-1.12-2.49-2.49,1.12-2.49,2.49-2.49Z"/><path class="cls-1" d="m34.25,23.26c-.84,0-1.61.26-2.26.7l-2.97-2.95c1.7-2.04,2.72-4.66,2.72-7.51,0-6.48-5.27-11.75-11.75-11.75s-11.75,5.27-11.75,11.75c0,2.85,1.03,5.47,2.73,7.51l-2.97,2.95c-.64-.44-1.42-.7-2.26-.7-2.21,0-4,1.79-4,4s1.79,4,4,4,4-1.79,4-4c0-.83-.25-1.6-.68-2.24l2.95-2.93c1.21,1.12,2.64,1.99,4.23,2.53l-1.46,5.65c-.09,0-.17-.03-.25-.03-2.21,0-4,1.79-4,4s1.79,4,4,4,4-1.79,4-4c0-1.59-.94-2.96-2.29-3.6l1.45-5.63c.75.15,1.52.23,2.3.23s1.56-.08,2.3-.23l1.46,5.63c-1.35.64-2.29,2.01-2.29,3.6,0,2.21,1.79,4,4,4s4-1.79,4-4-1.79-4-4-4c-.09,0-.17.02-.25.03l-1.46-5.65c1.59-.54,3.03-1.41,4.23-2.53l2.95,2.93c-.43.64-.68,1.41-.68,2.24,0,2.21,1.79,4,4,4s4-1.79,4-4-1.79-4-4-4Zm-17.22,10.99c0,1.38-1.12,2.5-2.5,2.5s-2.5-1.12-2.5-2.5,1.12-2.5,2.5-2.5,2.5,1.12,2.5,2.5Zm10.93,0c0,1.38-1.12,2.5-2.5,2.5s-2.5-1.12-2.5-2.5,1.12-2.5,2.5-2.5,2.5,1.12,2.5,2.5Zm-22.22-4.49c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5,2.5,1.12,2.5,2.5-1.12,2.5-2.5,2.5Zm14.25-6.01c-5.65,0-10.25-4.6-10.25-10.25S14.35,3.25,20,3.25s10.25,4.6,10.25,10.25-4.6,10.25-10.25,10.25Zm14.25,6.01c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5,2.5,1.12,2.5,2.5-1.12,2.5-2.5,2.5Z"/></svg>`,
  CLOSE = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="15" height="15" viewBox="0,0,256,256">
  <g fill="#6e6e7d" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(5.12,5.12)"><path d="M9.15625,6.3125l-2.84375,2.84375l15.84375,15.84375l-15.9375,15.96875l2.8125,2.8125l15.96875,-15.9375l15.9375,15.9375l2.84375,-2.84375l-15.9375,-15.9375l15.84375,-15.84375l-2.84375,-2.84375l-15.84375,15.84375z"></path></g></g>
  </svg>`,
  EDIT = `<?xml version="1.0" encoding="UTF-8"?><svg width="15" id="uuid-ddbf2eb8-4408-46c0-8822-cbdd95e61e96" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 27"><defs><style>.uuid-3fe67ed1-c395-437e-8a06-629ac592bca0{fill:#000000;stroke-width:0px;}</style></defs><path class="uuid-3fe67ed1-c395-437e-8a06-629ac592bca0" d="M7.97,13.74l-1.21,4.01c-.22.75-.02,1.55.54,2.1.4.39.92.59,1.45.59.22,0,.44-.04.66-.11l3.93-1.3c.72-.24,1.38-.65,1.91-1.18l10.85-10.85c.67-.67.8-1.71.33-2.53-.93-1.63-2.28-2.98-3.91-3.91-.83-.47-1.86-.33-2.53.33l-10.81,10.81c-.57.57-.99,1.27-1.22,2.04ZM8.98,19.01c-.25.08-.51.02-.7-.16-.19-.18-.26-.45-.18-.7l1.21-4.01c.02-.08.07-.15.1-.23,1.63.77,2.93,2.07,3.7,3.71-.07.03-.13.07-.19.09l-3.93,1.3ZM21.84,1.77c1.41.8,2.58,1.98,3.39,3.39.16.28.12.63-.11.86l-.89.89c-.96-1.75-2.39-3.18-4.14-4.14l.89-.89c.23-.23.58-.27.86-.11ZM19.03,3.83c1.81.89,3.25,2.33,4.14,4.14l-8.9,8.9s0,0,0,0c-.89-1.8-2.33-3.24-4.13-4.13.01-.01.02-.03.04-.05L19.03,3.83Z"/><path class="uuid-3fe67ed1-c395-437e-8a06-629ac592bca0" d="M26.02,12.8c-.38,0-.7.31-.7.7v2.78c0,4.98-4.06,9.04-9.04,9.04h-5.56c-4.98,0-9.04-4.06-9.04-9.04v-5.56C1.68,5.73,5.73,1.68,10.72,1.68h2.78c.38,0,.7-.31.7-.7s-.31-.7-.7-.7h-2.78C4.97.29.29,4.97.29,10.72v5.56c0,5.75,4.68,10.43,10.43,10.43h5.56c5.75,0,10.43-4.68,10.43-10.43v-2.78c0-.38-.31-.7-.7-.7Z"/></svg>`,
  NOTIFICATION = `<?xml version="1.0" encoding="UTF-8"?><svg  id="uuid-6f715c10-a670-421c-a2a4-dc66604b3175" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><defs><style>.uuid-20d4d9a6-683f-4c06-9257-0608c2d5a39d{fill:#ffffff;}</style></defs><path class="uuid-20d4d9a6-683f-4c06-9257-0608c2d5a39d" d="m15.59,12.87c-.44-.44-.7-1.05-.7-1.67v-3.8c0-2.99-2.24-5.45-5.14-5.82v-.58c0-.41-.34-.75-.75-.75s-.75.34-.75.75v.58c-2.89.37-5.14,2.84-5.14,5.82v3.8c0,.63-.25,1.24-.7,1.67-.45.45-.59,1.12-.35,1.7.24.59.81.97,1.44.97h3.28c0,1.22.99,2.21,2.21,2.21s2.21-.99,2.21-2.21h3.28c.64,0,1.2-.38,1.44-.97.24-.59.11-1.26-.35-1.7Zm-6.58,3.38c-.39,0-.71-.32-.71-.71h1.42c0,.39-.32.71-.71.71Z"/></svg>`,
  ACTIVENOTIFICATION = `<?xml version="1.0" encoding="UTF-8"?><svg id="uuid-00870021-e2cc-42c8-8f4d-78cfd0b21b14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><defs><style>.uuid-d6554401-5fe5-4086-af42-6ce7a5befe14{fill:#73767B;}.uuid-3047b030-b6d5-4058-a503-d236ef47f040{fill:#ec6446;}</style></defs><path class="uuid-d6554401-5fe5-4086-af42-6ce7a5befe14" d="M24.56,15.78v-.23c-.48,.18-.98,.3-1.49,.38,.03,1.91,.67,3.8,1.82,5.33,.17,.23,.27,.52,.27,.81,0,.74-.6,1.35-1.35,1.35H6.19c-.74,0-1.35-.6-1.35-1.35,0-.29,.1-.58,.27-.81,1.18-1.57,1.83-3.52,1.83-5.48v-4.47c0-4.44,3.62-8.06,8.06-8.06,.22,0,.43,.02,.65,.03,.39-.49,.83-.94,1.32-1.33-.64-.13-1.29-.21-1.97-.21C9.73,1.75,5.44,6.04,5.44,11.31v4.47c0,1.64-.54,3.27-1.53,4.58-.37,.49-.57,1.1-.57,1.71,0,1.57,1.28,2.85,2.85,2.85h4.52c.5,1.91,2.22,3.33,4.29,3.33s3.79-1.42,4.29-3.33h4.52c1.57,0,2.85-1.28,2.85-2.85,0-.61-.2-1.22-.57-1.71-.99-1.31-1.53-2.94-1.53-4.58Zm-9.56,10.97c-1.23,0-2.28-.76-2.72-1.83h5.44c-.44,1.07-1.49,1.83-2.72,1.83Z"/><circle class="uuid-3047b030-b6d5-4058-a503-d236ef47f040" cx="21.86" cy="8.14" r="6.39"/></svg>`,
  INACTIVENOTIFICATION = `<?xml version="1.0" encoding="UTF-8"?><svg id="notification-A" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><defs><style>.uuid-16284f96-34a5-4d2a-811e-360daa5fcaf5{fill:#a7a9ad;}</style></defs><path class="uuid-16284f96-34a5-4d2a-811e-360daa5fcaf5" d="m15.59,12.87c-.44-.44-.7-1.05-.7-1.67v-3.8c0-2.99-2.24-5.45-5.14-5.82v-.58c0-.41-.34-.75-.75-.75s-.75.34-.75.75v.58c-2.89.37-5.14,2.84-5.14,5.82v3.8c0,.63-.25,1.24-.7,1.67-.45.45-.59,1.12-.35,1.7.24.59.81.97,1.44.97h3.28c0,1.22.99,2.21,2.21,2.21s2.21-.99,2.21-2.21h3.28c.64,0,1.2-.38,1.44-.97.24-.59.11-1.26-.35-1.7Zm-6.58,3.38c-.39,0-.71-.32-.71-.71h1.42c0,.39-.32.71-.71.71Zm5.49-2.21H3.51l-.04-.1c.73-.72,1.15-1.72,1.15-2.74v-3.8c0-2.41,1.97-4.38,4.39-4.38,2.42,0,4.39,1.96,4.39,4.38v3.8c0,1.02.42,2.02,1.15,2.74l-.04.1Z"/></svg>`,
  ADD = `<?xml version="1.0" encoding="UTF-8"?><svg id="uuid-a991ade2-4404-4a3d-9c45-ce1056e6cc8f" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><defs><style>.uuid-2b2ce93c-51c9-4de5-a42f-d9bf904ca7f9{fill: #a7a9ad;}</style></defs><path class="uuid-2b2ce93c-51c9-4de5-a42f-d9bf904ca7f9" d="M12,.5h-4C3.86,.5,.5,3.86,.5,8v4c0,4.14,3.36,7.5,7.5,7.5h4c4.14,0,7.5-3.36,7.5-7.5v-4c0-4.14-3.36-7.5-7.5-7.5Zm6.5,11.5c0,3.58-2.92,6.5-6.5,6.5h-4c-3.58,0-6.5-2.92-6.5-6.5v-4C1.5,4.42,4.42,1.5,8,1.5h4c3.58,0,6.5,2.92,6.5,6.5v4Z"/><path class="uuid-2b2ce93c-51c9-4de5-a42f-d9bf904ca7f9" d="M13.54,9.5h-3v-3c0-.28-.22-.5-.5-.5s-.5,.22-.5,.5v3h-3c-.28,0-.5,.22-.5,.5s.22,.5,.5,.5h3v3c0,.28,.22,.5,.5,.5s.5-.22,.5-.5v-3h3c.28,0,.5-.22,.5-.5s-.22-.5-.5-.5Z"/></svg>`,
  PUBLISH = `<?xml version="1.0" encoding="UTF-8"?><svg id="uuid-f6172d48-d919-4b68-89cf-702ec8eab9a1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 27"><defs><style>.uuid-b4e1627e-b2c4-4e78-a97b-1c1cd1a3bc51{fill:#a7a9ad;}</style></defs><path class="uuid-b4e1627e-b2c4-4e78-a97b-1c1cd1a3bc51" d="M16.28,26.71h-5.56C4.97,26.71.29,22.03.29,16.28v-5.56C.29,4.97,4.97.29,10.72.29c.38,0,.7.31.7.7s-.31.7-.7.7C5.73,1.68,1.68,5.73,1.68,10.72v5.56c0,4.98,4.05,9.04,9.04,9.04h5.56c4.98,0,9.04-4.05,9.04-9.04,0-.38.31-.7.7-.7s.7.31.7.7c0,5.75-4.68,10.43-10.43,10.43Z"/><path class="uuid-b4e1627e-b2c4-4e78-a97b-1c1cd1a3bc51" d="M7.93,19.77c-.18,0-.36-.07-.49-.2-.24-.24-.27-.63-.07-.91l10.64-14.22-2.96-2.96c-.2-.2-.26-.5-.15-.76.11-.26.36-.43.64-.43h10.47c.18,0,.36.07.49.2s.2.31.2.49v10.47c0,.28-.17.54-.43.64-.26.11-.56.05-.76-.15l-2.96-2.96-14.22,10.64c-.12.09-.27.14-.42.14ZM17.22,1.68l2.2,2.2c.24.24.27.63.07.91l-8.11,10.83,10.83-8.11c.28-.21.67-.18.91.07l2.2,2.2V1.68h-8.1Z"/></svg>
`,
}

export enum ViewType {
  DATAGRID = 'dataGrid',
  CARDGALLERYVIEW = 'cardGalleryView',
  GALLERYGRIDVIEW = 'galleryGridView',
  CARDGRIDVIEW = 'cardGridView',
  GRIDVIEW = 'gridView',
  LISTVIEW = 'listView',
  CHARTVIEW = 'chartView',
}

export enum PieAxisColors {
  Green = '#42AE6E',
  Gold = '#C0B449',
  Gray = '#707070',
  Red = '#E9624A',
  DarkGray = '#262525',
}

export enum TabView {
  ACTIVITIES = 'Aktivitäten',
  DOCUMENTS = 'Dokumente',
  ANGEBOTE = 'Angebote',
  COMMENTS = 'Kommentare',
  HISTORY = 'Historie',
  ADDEXISTING = 'Vorhandenen hinzufügen',
  ADDNEW = 'Neu erstellen',
  AUFGABEN = 'Aufgaben',
  OVERVIEW = 'Overview',
  DETAILS = 'Details',
  MEDIA = 'Media',
  FLACHE = 'Fläche',
  EMAIL = 'E-Mail',
  TEMPLATE = 'Template',
  ATTACHEMENTS = 'Attachements',
  CRITERIA = 'Criteria',
  OFFERS = 'Offers',
  PUBLISH = 'Publish',
}

export enum contactSearchType {
  PERSONLISTE = 'Personliste',
  FIRMENLISTE = 'Firmenliste',
}

// Toast Notification Enums
export enum ToastType {
  ERROR = 'Error',
  SUCCESS = 'Success',
  INFO = 'Info',
  WARNING = 'Warning',
}
export interface IToast {
  message: string;
  type: ToastType;
  displayTime?: number;
}
export enum Position {
  TOP = 'top',
  BOTTOM = 'bottom',
  RIGHT = 'right',
  LEFT = 'left',
  CENTER = 'center',
}
export enum NotificationMessage {
  ArchiviertMessage = 'Erfolgreich archiviert',
  Empty = 'Unmöglich, Ihre Anfrage mit leeren Daten zu bearbeiten',
  EmptyComment = 'Es ist nicht möglich, einen leeren Kommentar hinzuzufügen',
  EmptyMembers = 'Mindestens ein Mitarbeiter sollte für die Delegation ausgewählt werden, oder ausgewählte Mitglieder sind bereits zugewiesen',
  Error = 'Bei der Bearbeitung Ihrer Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  NoChanges = 'Unmöglich, Ihren Antrag ohne Änderungen zu bearbeiten',
  ReaktiviertMessage = 'Erfolgreich reaktiviert',
  ReportSuccessGenerated = 'Der Bericht wurde erfolgreich erstellt',
  ValidArchiveMessage = 'Erfolgreich archiviert',
  InvalidLinkMessage = 'Sie haben einen ungültigen Link festgelegt',
  ValidInsertIntervalMessage = 'Sie sollten ein Intervall festlegen',
  ValidInsertMessage = 'Erfolgreich erstellt',
  ValidUploadMessage = 'Erfolgreich hochgeladen',
  ActiveNotificationMessage = 'Benachrichtigung aktivieren',
  SelectDepartmentWarning = 'Bitte wählen Sie mindestens eine Abteilung aus',
  RequiredFields = 'Sie sollten alle erforderlichen Felder ausfüllen',
  YouShouldAssignResponsibilityForAllEmployeesYouSelect = 'Sie sollten die Verantwortung für alle von Ihnen ausgewählten Mitarbeiter zuweisen',
  ItIsMandatoryToAttachADocumentAndDefineTheCategory = 'Es ist obligatorisch, ein Dokument beizufügen und die Kategorie zu definieren',
  YouAreNotAuthorizedToAccessThisSection = 'Sie sind nicht berechtigt, auf diesen Abschnitt zuzugreifen.',
  YouAreNotAuthorizedToCreateAMeasureBecauseYouDoNotHaveAnyControlResponsibilityForAUser = 'notificationMessage-youAreNotAuthorizedToCreateAMeasureBecauseYouDoNotHaveAnyControlResponsibilityForAUser',
  TheLinkedLegalObligationCannotBeFound = 'notificationMessage-theLinkedLegalObligationCannotBeFound',
  TheMeasureYouAreTryingToAccessCannotBeFound = 'notificationMessage-theMeasureYouAreTryingToAccessCannotBeFound',
  DelegationLetterUpdated = 'Der Delegationsbrief wurde erfolgreich aktualisiert',
  UserCreatedSuccess = 'user.created.success',
  DelegationLetterHasBeenSigned = 'notificationMessage-delegationLetterInserted',
  ObligationWithoutDelegationLetter = 'You should get a delegation letter with this legal obligation before assigning it',
  ContainerSavedSuccessfully = 'notificationMessage-container-and-legal-obligations-saved-successfully',
  LabelMustBeUnique = 'notificationMessage-labelMustBeUnique',
  MeasureSubjectMustBeUnique = 'notificationMessage-measureSubjectMustBeUnique',
  CustomerAssignedSuccessfully = 'notificationMessage-customer-assigned-successfully',
  InsertedSuccessfully = 'notificationMessage-insertedSuccessfully',
  DeletedSuccessfully = 'notificationMessage-deletedSuccessfully',
  sendMailInvitation = 'notificationMessage-sendMailInvitation',
  CreatedSuccessfully = 'notificationMessage-createdSuccessfully',
  UpdatedSuccessfully = 'notificationMessage-updatedSuccessfully',
  ArchivedSuccessfully = 'notificationMessage-archivedSuccessfully',
  NoUpdatesToApply = 'notificationMessage-noUpdatesToApply',
  FileHasAlreadyBeenUploaded = 'notificationMessage-fileHasAlreadyBeenUploaded',
  PleaseNoteWithTheDocumentationNotedTheOngoingFulfillmentOfTheDelegatedObligationIsConfirmedOnceThisObligationWillThenBeFinallyAcknowledgedAndWillNotAppearInTheListOfObligationsForResubmission = 'notificationMessage-pleaseNoteWithTheDocumentationNotedTheOngoingFulfillmentOfTheDelegatedObligationIsConfirmedOnceThisObligationWillThenBeFinallyAcknowledgedAndWillNotAppearInTheListOfObligationsForResubmission',
  SomethingWentWrongWithTheCurrentStatePleaseTryReloadThePage = 'notificationMessage-somethingWentWrongWithTheCurrentState.PleaseTryReloadThePage',
  YourRequestCouldNotBeCompletedBecauseSomeDataHasBeenUpdatedPleaseReviewTheNewData = 'notificationMessage-yourRequestCouldNotBeCompletedBecauseSomeDataHasBeenUpdated.PleaseReviewTheNewData.',
  ErrorLoadingData = 'notificationMessage-errorLoadingData',
  LegalIdNotFound = 'notificationMessage-legalIdNotFound',
  NoSubprojectsFound = 'notificationMessage-noSubprojectsFound',
  ErrorLoadingDepartments = 'notificationMessage-errorLoadingDepartments',
  ErrorLoadingLegalInfo = 'notificationMessage-errorLoadingLegalInfo',
  ErrorLoadingLegalDomain = 'notificationMessage-errorLoadingLegalDomain',
  ErrorLoadingPermitRegulatory = 'notificationMessage-errorLoadingPermitRegulatory',
  ErrorGeneral = 'error.general',
  ErrorSomethingWentWrong = 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  FailedToPersistPermissions = 'notificationMessage-failedToPersistPermissions',
  ErrorLoadingPermissions = 'notificationMessage-errorLoadingPermissions',
  InvalidPermissionsResponseFormat = 'notificationMessage-invalidPermissionsResponseFormat',
  ErrorLoadingPickList = 'notificationMessage-errorLoadingPickList',
  NoPermissionToPersist = 'notificationMessage-noPermissionToPersist',
  permissionInfoUpdateUser = 'notificationMessage-permissionInfoUpdateUser',
  UnknownType = 'notificationMessage-unknownType',
  ParentFound = 'notificationMessage-parentFound',
  GrandParentMissing = 'notificationMessage-grandParentMissing',
  ParentNotBought = 'notificationMessage-parentNotBought',
  DomainHasObligations = 'notificationMessage-domainHasObligations',
  DomainHasLawsNoObligations = 'notificationMessage-domainHasLawsNoObligations',
  DomainHasNoLaws = 'notificationMessage-domainHasNoLaws',
  LawHasObligations = 'notificationMessage-lawHasObligations',
  LawHasNoObligations = 'notificationMessage-lawHasNoObligations',
  LegalObligationSelected = 'notificationMessage-legalObligationSelected',
  ObligationNotPurchased = 'notificationMessage-obligationNotPurchased',
  domainNotPurchased = 'notificationMessage-domainNotPurchased',
  dataIsPublished = 'notificationMessage-dataIsPublished',
  emailAndLoginUsed = 'notificationMessage-bothUsed',
  loginUsed = 'notificationMessage-loginUsed',
  emailUsed = 'notificationMessage-emailUsed',
  updateIsNotPermitted = 'update.is.not.permitted',
  UpdateError = 'notificationMessage-updateError',
  InvitationSent = 'notificationMessage-invitationSent',
  InvitationError = 'notificationMessage-invitationError',
  LabelCannotBeEmpty = 'LabelCannotBeEmpty',
}

export class Marker {
  location: string;
  tooltip: Tooltip;
  iconSrc?: string;
}
export class Tooltip {
  text: string;
  isShown?: boolean = false;
  iconSrc?: string;
}
export enum ToastAnimationShowType {
  FADE = 'fade',
  SLIDE = 'slide',
}
export enum ObjectType {
  BUILDING = 'Gebäude',
  FLOOR = 'Etage',
  UNIT = 'Unit',
}

export interface IToastAnimation {
  show?: IShowHide;
  hide?: IShowHide;
}

export enum ChangeMode {
  Insert = 'insert',
  Remove = 'remove',
}
export enum BirthdayDetail {
  Today = 'Heute',
  Tomorrow = 'Morgen',
  NextWeek = 'Nächste Woche',
}

export interface PositionI {
  position: PositionIValue;
}
export interface PositionIValue {
  my: Position;
  at: Position;
  of?: any;
}

export interface IShowHide {
  type: ToastAnimationShowType;
  duration: number;
  from?: number | PositionI;
  to?: number | PositionI;
}

export enum WeekDays {
  Mon = 'Montag',
  Tue = 'Dienstag',
  Wed = 'Mittwoch',
  Thu = 'Donnerstag',
  Fri = 'Freitag',
  Sat = 'Samstag',
  Sun = 'Sonntag',
}

export enum PickListStatus {
  INVITED = 'Invited',
  ACTIVE = 'Active',
  NEW = 'New',
  ARCHIVED = 'Archived',
}

export interface IRole {
  isAdmin: boolean;
  isManager: boolean;
}

export enum LegalTypes {
  LEGAL = 'Legal',
  PERMIT = 'Permission',
  CORPORATE = 'Corporate',
  ALL = 'All',
}

export enum LegalTypesValues {
  LEGAL = '0',
  PERMIT = '1',
  CORPORATE = '2',
}

export enum MeasureResourceResponsibility {
  CONTROL = 'Kontrolle',
  EXECUTION = 'Ausführung',
}
export enum MeasureResourceResponsibilityResponsibilityKey {
  CONTROL = 'legalObligation-ControlResponsibility',
  EXECUTION = 'legalObligation-ExecutionResponsability',
}

export enum ArchiveState {
  ARCHIVED = 'Archivieren',
  ACTIVE = 'active',
  ALL = 'all',
}

export interface IRole {
  isAdmin: boolean;
  isManager: boolean;
}

export enum ROLES {
  ADMIN = 'Admin',
  MANAGEMENT = 'Management',
  LEADERSHIP = 'Führungskraft',
  EMPLOYEE = 'Mitarbeiter',
  SUPERADMIN = 'SUPER_ADMIN',
}

export enum LegalObligationkind {
  PermanentObligation = '0',
  OneTimeObligationWithDeadline = '1',
  OneTimeObligationWithoutDeadline = '2',
  RepetitiveObligationWithDeadline = '3',
  RepetitiveObligationWithoutDeadline = '4',
}

export enum MeasureResourceStatus {
  Open = 0,
  Due = 1,
  Overdue = 2,
  Noted = 3,
  Finished = 4,
  Permanent = 5,
  Repetitive = 6,
  Unknown = 100,
}

export enum PersonResponsibility {
  Control = '0',
  Execution = '1',
}

export enum PickListName {
  DEPAREMENT = 'Department',
  FUNCTION = 'Function',
  POSITION = 'Position',
  STATUS = 'Status',
  SALUTATION = 'Salutation',
  KIND = 'Kind',
}

export enum PickListPermission {
  CanEdit = 'enum-pickListPermission-canEdit',
  CanSee = 'enum-pickListPermission-canSee',
}

export interface Email {
  From?: string;
  To: string;
  Cc?: string[];
  Subject: string;
  Body: string;
}

export enum FaqsType {
  CATEGORY = '0',
  QUESTION = '1',
  ANSWER = '2',
}

export interface ITabItem {
  title: string;
  total?: number;
  visible?: boolean;
}

export enum UserTab {
  UserInformation = 'enum-tabView-userInformation',
  UserRights = 'enum-tabView-userRights',
}

export interface ISchedulingDate {
  Id: string;
  Description: string;
}

export enum SchedulingDate {
  April = '1st April',
  JULY = '1st July',
  October = '1st October',
  JANUARY = '1st January',
}

export enum DepartmentTypes {
  Operational = 1,
  Management = 0,
}
export enum DepartmentTypesValues {
  Operational = 'enum-department-departmentType-operational',
  Management = 'enum-department-departmentType-management',
}

export enum NotificationSource {
  SPECIFIC = 'enum-category-specific',
  MEASURE = 'enum-category-measure',
  LEGAL_OBLIGATION = 'enum-category-legalObligation',
  DELEGATION_LETTER = 'enum-category-delegationLetter',
  ARCHIEVE_USER = 'enum-category-archieveUser',
}

export enum NotificationCategory {
  ARCHIVE_USER = 'enum-category-archiveUser',
  CUSTOM = 'enum-category-custom',
  DELEGATION_LETTER = 'enum-category-delegationLetter',
  ABSENCE = 'enum-category-absence',
  LEGAL_OBLIGATION = 'enum-category-legalObligation',
  MEASURE = 'enum-category-measure',
  MOCK = 'enum-category-mock',
}

export enum ContainerEditorAction {
  CREATE = 'create',
  EDIT = 'edit',
  DUPLICATE = 'duplicate',
}

export enum ReportKind {
  NEWSLETTER = 0,
  QUARTERLY_REPORT = 1,
  ANNUAL_REPORT = 2,
  RELEASE_NOTE = 3,
}

export enum PopupMode {
  CREATE = 'create',
  EDIT = 'edit',
}

export enum ModuleData {
  LEGAL_COMPLIANCE = 'Legal Compliance',
  PERMIT_COMPLIANCE = 'Permitt Compliance',
  CORPORATE_COMPLIANCE = 'Corporate Compliance',
  RISK_MANAGEMENT = 'Risikomanagement',
}

export const DELEGATION_LETTER_FIRST_PART =
  'Die Konkretisierung und Aktualisierung Ihrer Pflichten entnehmen Sie bitte der Datenbank des Compliance-Managementsystems. Durch die Dokumentation Ihrer Pflichtenerfüllung im System weisen Sie nach, dass Sie Ihren oben genannten Aufgaben nachgekommen sind und sich wiederkehrend über etwaige Anpassungen Ihrer Aufgaben informiert haben.';

export const DELEGATION_LETTER_SECOND_PART = `§ 9 des Gesetzes über Ordnungswidrigkeiten (OWiG):
"(1) Handelt jemand
1. als vertretungsberechtigtes Organ einer juristischen Person oder als Mitglied eines solchen Organs, 2. als vertretungsberechtigter Gesellschafter einer rechtsfähigen Personengesellschaft oder
3. als gesetzlicher Vertreter eines anderen, so ist ein Gesetz, nach dem besondere persönliche Eigenschaften, Verhältnisse oder Umstände (besondere persönliche Merkmale) die Möglichkeit der Ahndung begründen, auch auf den Vertreter anzuwenden, wenn diese Merkmale zwar nicht bei ihm, aber bei dem Vertretenden vorliegen.
(2) Ist jemand von dem Inhaber eines Betriebes oder einem sonst dazu Befugten 1. beauftragt, den Betrieb ganz oder zum Teil zu leiten, oder
2. ausdrücklich beauftragt, in eigener Verantwortung Aufgaben wahrzunehmen, die dem Inhaber des Betriebes obliegen, und handelt er auf Grund dieses Auftrages, so ist ein Gesetz, nach dem besondere persönliche Merkmale die Möglichkeit der Ahndung begründen, auch auf den Beauftragten anzuwenden, wenn diese Merkmale zwar nicht bei ihm, aber bei dem Inhaber des Betriebes vorliegen. Dem Betrieb im Sinne des Satzes 1 steht das Unternehmen gleich. Handelt jemand auf Grund eines entsprechenden Auftrages für eine Stelle, die Aufgaben der öffentlichen Verwaltung wahrnimmt, so ist Satz 1 sinngemäß anzuwenden.
(3) Die Absätze 1 und 2 sind auch dann anzuwenden, wenn die Rechtshandlung, welche die Vertretungsbefugnis oder das Auftragsverhältnis begründen sollte, unwirksam ist."

§ 13 Absatz 2 Arbeitsschutzgesetz (ArbSchG):
"Der Arbeitgeber kann zuverlässige und fachkundige Personen schriftlich damit beauftragen, ihm obliegende Aufgaben nach diesem Gesetz in eigner Verantwortung wahrzunehmen."

§ 15 Absatz 1 Siebtes Buch Sozialgesetzbuch (SGB VII):
"(1) Die Unfallversicherungsträger erlassen als autonomes Recht Unfallverhütungsvorschriften über
1. Einrichtungen, Anordnungen und Maßnahmen, welche die Unternehmer zur Verhütung von Arbeitsunfällen, Berufskrankheiten und arbeitsbedingten Gesundheitsgefahren zu treffen haben, sowie die Form der Übertragung dieser Aufgaben auf andere Personen."

§ 13 der Unfallverhütungsvorschrift „Grundsätze der Prävention" (DGUV Vorschrift 1):
"Der Unternehmer kann zuverlässige und fachkundige Personen schriftlich damit beauftragen, ihm nach Unfallverhütungsvorschriften obliegende Aufgaben in eigener Verantwortung wahrzunehmen. Die Beauftragung muss den Verantwortungsbereich und Befugnisse festlegen und ist vom Beauftragten zu unterzeichnen. Eine Ausfertigung der Beauftragung ist ihm auszuhändigen."`;

export enum STATE_COLORS {
  OPEN = '#989898',
  DUE = '#fee583',
  OVERDUE = '#ef7461',
  PERMANENT = '#a6d189',
  REPETITIVE = '#69bb76',
  FINISHED = '#39aa64',
  NOTED = '#6b85c0',
}

export enum PermissionContext {
  WORLD_MAP = 'location',
  DASHBOARD = 'dashboard',
  ORGANISATION = 'organisation',
  LEGAL_PFLICHTEN = 'legalPflichten',
  PERMIT_PFLICHTEN = 'permitPflichten',
  CORPORATE_PFLICHTEN = 'corporatePflichten',
  DELAGATION = 'delagation',
  REGELWERKE = 'regelwerke',
  AKTUALISIERUNG = 'aktualisierung',
  DOCUMENTATION = 'documentation',
  TRAININGSCENTER = 'trainingscenter',
  BENUTZER = 'benutzer',
  RISIKOMANAGEMENT = 'risikomanagement',
  SUBSTITUTE = 'substitute',
  COMPANY_STRUCTURE = 'company-Structure',
  MEASURE = 'measure',
  SUBSTITUTION = 'substitution',
  INTERNAL_ROLE = 'internal_role',
  COMPANYSELECTION = 'company_selection',
  GROUP_ACCESS = 'group_access',
}

export enum PERMISSION_OPTION {
  EDIT = 'edit',
  VIEW = 'view',
  NONE = 'none',
}

export enum COMMENT_IDENTIFIER {
  NOTE = 'Note',
  SYSTEM_NOTIFICATION = 'SystemNotification',
}

export enum IntervalUnit {
  DAY = '0',
  WEEK = '1',
  MONTH = '2',
  YEAR = '3',
}

export enum SubstitutionType {
  Open = '0',
  Declined = '1',
  Accepted = '2',
  Active = '3',
  Completed = '4',
  Canceled = '5',
  Archived = '6',
}
